<template>
    <div class="card">
        <TabView @tab-change="handleTabChange">
            <TabPanel header="สรุปจำนวนพื้นที่เสี่ยงภัย">
                <report-risk-area-amount></report-risk-area-amount>
            </TabPanel>
            <TabPanel header=" กราฟสรุปจำนวนพื้นที่เสี่ยงภัย">
                <report-risk-area-graph></report-risk-area-graph>
            </TabPanel>
        </TabView>
    </div>
</template>

<script>
import reportRiskAreaAmount from './ReportRiskAreaAmount';
import reportRiskAreaGraph from './ReportRiskAreaGraph';

export default {
    components: {
        reportRiskAreaAmount,
        reportRiskAreaGraph
    },
    data() {
      return{
          
      }    
    },

    watch:{

    },

    mounted(){
    },

    methods: {
        handleTabChange(newTab){
            console.log(newTab.tab.$vnode.componentOptions.propsData.header)
        }
    }
}
</script>